module.exports = __webpack_public_path__ + "img/home_04.c1624cf7.png";